interface ParticipantSearchRow {
  participant_id?: number;
  name?: string;
  email?: string;
  organization?: string;
  role?: string;
  status?: string;
  user?: {
    first_name?: string;
    last_name?: string;
    user?: string | null;
    locations?: Array<{ locations_name?: string }> | null;
  };
  data?: {
    comments?: string;
    additional_comments?: string;
  };
}

const ROLE_LABELS: Record<string, string> = {
  attendee: 'deltager',
  instructor: 'instruktør',
  assistant: 'assistent',
};

const STATUS_LABELS: Record<string, string> = {
  waitlist: 'venteliste',
  pending: 'tilmeldt',
  shownup: 'mødt op',
  requires_attention: 'kræver opmærksomhed',
  completed: 'gennemført',
  not_appear: 'udeblevet',
  cancellation: 'afbud',
  not_participant: 'ikke deltager',
  cancelled: 'afbud',
  afbud: 'afbud',
};

function participantSearchHaystack(row: ParticipantSearchRow): string {
  const parts: Array<string | undefined | null> = [
    row.name,
    row.email,
    row.organization,
    row.role,
    row.status,
    row.user?.first_name,
    row.user?.last_name,
    row.user?.user ?? '',
    row.user?.locations?.[0]?.locations_name,
    row.data?.comments,
    row.data?.additional_comments,
  ];

  const roleKey = (row.role ?? '').toLowerCase();
  const statusKey = (row.status ?? '').toLowerCase();
  if (ROLE_LABELS[roleKey]) parts.push(ROLE_LABELS[roleKey]);
  if (STATUS_LABELS[statusKey]) parts.push(STATUS_LABELS[statusKey]);

  return parts
    .filter((v) => v != null && String(v).trim() !== '')
    .map((v) => String(v).toLowerCase())
    .join(' ');
}

export function filterParticipantDisplayItemsBySearch<T extends ParticipantSearchRow>(
  items: T[],
  searchQuery?: string | null
): T[] {
  const search = searchQuery?.trim().toLowerCase();
  if (!search) {
    return items;
  }

  return items.filter((row) => {
    if (row.participant_id === 0) {
      return false;
    }
    return participantSearchHaystack(row).includes(search);
  });
}

export function eventParticipantDisplayTotalCount(
  items: { participant_id?: number }[]
): number {
  if (items.length === 0) {
    return 0;
  }
  if (items.length === 1 && items[0].participant_id === 0) {
    return 1;
  }
  return items.length;
}
